<template>
  <div class="localization-certificate">
    <div
      class="localization-certificate-card"
      :style="{
        backgroundImage: 'url(https://webcdn.tengmoney.com/usm/Fp4jR54Gy_jd5P5v1NSFt-T1rb9U-620-180.png)',
      }"
      @click="clickCertificate"
    >
      <div class="localization-certificate-card-title text-ellipsis-line-2">资质证书</div>
      <div class="localization-certificate-card-sub">
        点击查看证书详情<span class="localization-certificate-card-sub-right cz-iconfont czyoujiantou"></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { useUserStore } from '@shared/store';
  import { getQueryString } from '@shared/utils';

  const userStore = useUserStore();
  const currentCorpId = getQueryString('currentCorpId');
  const agentId = getQueryString('agentId');
  const staffId = getQueryString('staffId') || userStore.viewStaffInfo.staffId;

  const clickCertificate = () => {
    _jt_.sendTracker({
      event_type: 'click',
      block_desc: `${import.meta.env.VITE_PF_LOCALIZATION_CERTIFICATE_DOMAIN}/mkas-cli-cert/personal-certificate`,
      button_desc: 'enter_btn',
      parameters: {},
    });
    location.replace(
      `${
        import.meta.env.VITE_PF_LOCALIZATION_CERTIFICATE_DOMAIN
      }/mkas-cli-cert/personal-certificate?currentCorpId=${currentCorpId}&agentId=${agentId}&staffId=${staffId}&title=${
        document.title
      }`
    );
  };
</script>

<style lang="less" scoped>
  .localization-certificate {
    position: relative;
    margin: 0.12rem 0 0.02rem;
    height: 1.8rem;

    &-card {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 0 0.1rem 0.36rem;
      width: 100%;
      height: 1.8rem;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      text-align: left;
      &-title {
        width: 60%;
        font-size: 0.36rem;
        font-weight: bold;
        line-height: 0.4rem;
        color: #111;
      }
      &-sub {
        margin-top: 0.2rem;
        font-size: 0.22rem;
        color: #999;
        &-right {
          margin-left: 0.08rem;
          font-size: 0.22rem;
          color: #999;
        }
      }
    }
  }
</style>
